<template>
  <div id="user-app">
    <TopBar></TopBar>
    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12" class="main-column">
            <v-progress-circular
              v-if="loading"
              indeterminate
              size="50"
            ></v-progress-circular>
            <router-view v-else></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import TopBar from "@/components/TopBar.vue";
import { messaging, messaging_pub_key } from "@/firebase";
import { G_REGISTER_USER_NOTIFICATION_TOKEN, G_USER_SELECT_GET_DEFAULTS } from '@/store/modules/helpers/action.type';
import { mapGetters, mapMutations } from 'vuex';
import { G_SET_FCM_TOKEN } from '@/store/modules/helpers/mutation.type';

export default {
  name: "UserApp",
  components: {
    TopBar,
  },
  data: () => ({
    fcm_token: null,
    has_notification_permission: false,
  }),
  beforeCreate() {
    this.$store.commit("set_loading", true);
    this.$store.dispatch(G_USER_SELECT_GET_DEFAULTS, { watch: true })
      .then(() => {
        this.$store.commit("set_loading", false);

        if ('Notification' in window && messaging)
          return this.subscribe_to_push();
      })
      .then(() => {
        if (messaging) {
          messaging.onMessage(payload => {
            // If a notification is received while the app is open, show a normal notification.
            // TODO: Maybe we should add some different behaviour, like showing an in-app pop-up.
            navigator.serviceWorker.getRegistration()
              .then(reg => {
                const notification = payload.notification;
                reg.showNotification(notification.title, notification);
              });
          });
        }
      });
  },
  computed: {
    ...mapGetters([
      "loading",
    ]),
  },
  methods: {
    async request_notification_permission() {
      const ans = await Notification.requestPermission()
      if (ans === "granted") {
        this.has_notification_permission = true;
      } else {
        this.has_notification_permission = false;
        throw new Error("Notification permission not granted");
      }
    },
    async subscribe_to_push() {
      const registration = await navigator.serviceWorker.getRegistration();
      console.important("We have notification permission!");
      const token = await messaging.getToken({
        serviceWorkerRegistration: registration,
        vapidKey: messaging_pub_key
      });
      console.important(`FCM token: ${token}`);
      this.fcm_token = token;
      await this.register_token(token);
      this.set_fcm_token(token);

      console.important(`FCM token registered`);
    },
    async register_token(token) {
      this.$store.dispatch(G_REGISTER_USER_NOTIFICATION_TOKEN, token);
    },
    ...mapMutations([
      "set_loading",
    ]),
    ...mapMutations({
      "set_fcm_token": G_SET_FCM_TOKEN,
    }),
  },
}
</script>
<style lang="scss">
#nav {
  padding: 30px;
  font-family: 'Rubik', sans-serif;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>